import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../api/axiosConfig';

const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

export const fetchStates = createAsyncThunk(
  'states/fetchStates',
  async (token, { rejectWithValue }) => {
    try {
      const response = await axios.get('/api/admin/states', {
        headers: { Authorization: `Bearer ${token}` }
      });
      return { data: response.data, timestamp: Date.now() };
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to fetch states');
    }
  }
);

const initialState = {
  list: [],
  loading: false,
  error: null,
  lastFetched: null
};

const stateSlice = createSlice({
  name: 'states',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStates.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.lastFetched = action.payload.timestamp;
      })
      .addCase(fetchStates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const selectStates = (state) => state.states.list;
export const selectStatesLoading = (state) => state.states.loading;
export const selectShouldRefetchStates = (state) => {
  if (!state.states.lastFetched) return true;
  return Date.now() - state.states.lastFetched > CACHE_DURATION;
};

export const { clearError } = stateSlice.actions;
export default stateSlice.reducer;
